import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const NextIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M7.91197 3C7.74938 3.00004 7.59051 3.04857 7.45565 3.13938C7.32078 3.23019 7.21607 3.35916 7.15489 3.5098C7.09371 3.66043 7.07885 3.82589 7.11219 3.98501C7.14554 4.14414 7.22559 4.28971 7.3421 4.40311L14.9371 11.9981L7.3421 19.593C7.26367 19.6683 7.20104 19.7585 7.1579 19.8584C7.11476 19.9582 7.09197 20.0656 7.09086 20.1743C7.08976 20.2831 7.11036 20.3909 7.15146 20.4916C7.19256 20.5923 7.25333 20.6837 7.33022 20.7606C7.40711 20.8375 7.49857 20.8983 7.59924 20.9394C7.69991 20.9805 7.80777 21.0011 7.91651 21C8.02524 20.9989 8.13266 20.9761 8.23247 20.9329C8.33229 20.8898 8.42249 20.8272 8.4978 20.7487L16.6707 12.5759C16.8239 12.4226 16.91 12.2148 16.91 11.9981C16.91 11.7814 16.8239 11.5735 16.6707 11.4202L8.4978 3.24742C8.42164 3.16913 8.33055 3.1069 8.22993 3.0644C8.12931 3.0219 8.0212 3.00001 7.91197 3Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(NextIcon)
